import { useRef } from "react";
import { Paperclip, X, FileText, Image } from "lucide-react";
import { toast } from "sonner";
import { fmtSize } from "../../lib/files";

const TYPES = ["image/jpeg", "image/png", "image/webp", "application/pdf"];
const MAX = 5 * 1024 * 1024;

export default function AttachmentPicker({ files, onChange }) {
  const input = useRef(null);
  const add = (list) => {
    const next = [...files];
    for (const f of list) {
      if (next.length >= 3) { toast.error("3 pièces jointes maximum"); break; }
      if (!TYPES.includes(f.type)) { toast.error(`« ${f.name} » : format non accepté (JPG, PNG, WEBP, PDF)`); continue; }
      if (f.size > MAX) { toast.error(`« ${f.name} » dépasse 5 Mo`); continue; }
      next.push(f);
    }
    onChange(next);
    input.current.value = "";
  };
  return (
    <div>
      <input ref={input} type="file" multiple accept=".jpg,.jpeg,.png,.webp,.pdf" className="hidden"
        onChange={(e) => add(Array.from(e.target.files || []))} data-testid="attachments-input" />
      {files.length < 3 && (
        <button type="button" onClick={() => input.current.click()} data-testid="attachments-add-button"
          className="flex w-full items-center justify-center gap-2 rounded-lg border border-dashed border-slate-300 px-4 py-4 text-sm text-slate-600 transition-colors hover:border-blue-400 hover:text-blue-700">
          <Paperclip className="h-4 w-4" /> Ajouter une photo ou un PDF (facultatif, 5 Mo max, 3 fichiers)
        </button>
      )}
      <ul className="mt-2 space-y-1.5">
        {files.map((f, i) => (
          <li key={`${f.name}-${i}`} className="flex items-center gap-2 rounded-md bg-slate-50 px-3 py-2 text-sm" data-testid={`attachment-item-${i}`}>
            {f.type === "application/pdf" ? <FileText className="h-4 w-4 text-rose-600" /> : <Image className="h-4 w-4 text-blue-600" />}
            <span className="min-w-0 flex-1 truncate">{f.name}</span>
            <span className="text-xs text-slate-400">{fmtSize(f.size)}</span>
            <button type="button" aria-label="Retirer" onClick={() => onChange(files.filter((_, j) => j !== i))} data-testid={`attachment-remove-${i}`}>
              <X className="h-4 w-4 text-slate-500" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
